import Page from '../../../domain/Page/Page';
import { useAppDispatch } from '../../../store/hook';
import { updateNextPageId } from '../../../store/wizzard/wizzardStep';
import storage from '../../util/storage';
import { roleBackOfficeList } from '../../../domain/User/Erole';
import { useFolderId } from '../../../infrastructure/hooks';

interface Props {
  page: Page,
  currentPageId: string,
  number: string,
  progress: number,
}

function handleClickStep(dispatch, id, folderId: string | null) {
  dispatch(updateNextPageId({ 'id': id }))
  // Use URL with folderId if available
  const basePath = folderId ? `/dossier/${folderId}/form` : '/form'
  window.location.href = `${basePath}/${id}`
}

const WizardStepComponent = ({ page, currentPageId, number, progress }: Props): JSX.Element => {
  const dispatch = useAppDispatch()
  const { folderId } = useFolderId()
  const dossierState = storage.getDossierState(folderId)
  const isComplete = page.id !== currentPageId && progress === 100
  const wizzardActive = page.id === currentPageId ? 'wizzard__step--active' : ''
  const userRole = localStorage.getItem('role');
  const isBackOfficeUser = (userRole && roleBackOfficeList.includes(userRole));

  function checkInvalidElements() {
    const data = JSON.parse(localStorage.getItem('invalidElements') ?? '[]');

    if (!Array.isArray(data) || data.length === 0) {
      return false;
    }

    return data.every(item => item.receipt_id !== null);
  }
  const isOnlyReceiptToCorrect = checkInvalidElements();

  const getWizzardClassName = () => {
    if (isOnlyReceiptToCorrect) return 'wizzard__step--complete-signed';
    if (!isComplete) return '';

    const isNotInSignatureProcess = dossierState !== 'signed' && dossierState !== 'signature';
    if (isNotInSignatureProcess) {
      return 'wizzard__step--complete';
    }

    return 'wizzard__step--complete-signed';
  };

  const handleWizzardCompleteClassName = getWizzardClassName();
  const wizzardBackOffice = isBackOfficeUser ? 'wizzard__step--back-office' : ''

  // Click on wizard activated if folder not in 'signature' or 'signed' or if specific role
  const wizardElementWithClickEvent =
    ((isComplete && 'signed' !== dossierState && 'signature' !== dossierState) || isBackOfficeUser)
    && (
      isOnlyReceiptToCorrect ?
        <div>
          <div className="step__number">{number}</div>
          <div className="step__title">{page.title}</div>
        </div>
        :
        <div onClick={() => handleClickStep(dispatch, page.id, folderId)}>
          <div className="step__number">{number}</div>
          <div className="step__title">{page.title}</div>
        </div>
    ) || (
      <>
        <div className="step__number">{number}</div>
        <div className="step__title">{page.title}</div>
      </>
    )

  return (
    <div className={`wizzard__step ${wizzardActive} ${wizzardBackOffice} ${handleWizzardCompleteClassName}`}>
      <div className="step__progression">
        <div className="progress" style={{ width: `${progress}%` }}></div>
      </div>
      {wizardElementWithClickEvent}
    </div>
  );
}

export default WizardStepComponent;
